import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const SectorulAdministrativBisericesc: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Administrativ-Bisericesc
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Augustin Gheorghiu
          </Typography>
          <Typography variant="body1">
            Sectorul Administrativ-Bisericesc se ocupă de administrarea 
            activităților administrative și bisericești ale eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectorulAdministrativBisericesc;
